export const COMMUNICATION_ALERTS_REFRESH_EVENT = 'communications:alerts-refresh';

export const emitCommunicationAlertsRefresh = () => {
    if (typeof window === 'undefined') {
        return;
    }

    window.dispatchEvent(new CustomEvent(COMMUNICATION_ALERTS_REFRESH_EVENT));
};
